import GATSBY_COMPILED_MDX from "/opt/build/repo/src/pages/braiins-pool/btc-mining-setup.en.mdx";
import React from 'react';
import {slugify} from 'lib/url';
import {useStaticQuery, graphql} from 'gatsby';
import {createHead} from 'src/components/Seo';
import {Utils} from '../components/Utils';
import Layout from '../components/Layout';
import {PageHeader} from '../components/PageHeader';
import {NextPrevious} from '../components/NextPrevious';
import {PageTabs} from '../components/PageTabs';
import {Main} from '../components/Main';
import {useMetadata} from '../util/hooks/useMetadata';
import {LastModifiedDate} from '../components/LastModifiedDate';
function Default({pageContext, children, location, Title}) {
  const {frontmatter = {}} = pageContext;
  const {tabs, title, theme: frontmatterTheme, date} = frontmatter;
  const {interiorTheme} = useMetadata();
  const prefixData = useStaticQuery(graphql`
        query PathPrefix {
            site {
                pathPrefix
            }
        }
    `);
  const pathPrefix = prefixData.site?.pathPrefix;
  const slug = pathPrefix ? location.pathname.replace(pathPrefix, '') : location.pathname;
  const getCurrentTab = () => {
    if (!tabs) return '';
    return slug.split('/').filter(Boolean).slice(-1)[0] || slugify(tabs[0]);
  };
  const currentTab = getCurrentTab();
  const theme = frontmatterTheme || interiorTheme;
  return React.createElement(Layout, {
    tabs: tabs,
    homepage: false,
    theme: theme
  }, React.createElement(PageHeader, {
    title: Title ? React.createElement(Title) : title,
    tabs: tabs,
    theme: theme
  }), tabs && React.createElement(PageTabs, {
    title: title,
    slug: slug,
    tabs: tabs,
    currentTab: currentTab
  }), React.createElement(Main, {
    padded: true
  }, children, date != null && React.createElement(LastModifiedDate, {
    date: date
  })), React.createElement(NextPrevious, {
    pageContext: pageContext,
    location: location,
    tabs: tabs
  }), React.createElement(Utils));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Default, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = createHead();
